"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForceRerender = void 0;
const react_1 = require("react");
function useForceRerender() {
    const [, setImaginaryState] = react_1.useState(0);
    return react_1.useCallback(() => {
        setImaginaryState(Date.now());
    }, [setImaginaryState]);
}
exports.useForceRerender = useForceRerender;
//# sourceMappingURL=useForceRerender.js.map